
module Meevo.Plugins.BusinessInfo {

    export class ServiceCategoryDisplayOrderSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        public serviceCategories: any
        public addedServiceCategories: any;
        public servicePriorityModel: any;
        public securityKeyDelete: any;
        public selectedCategory: any;
        public isAddingCategory = false;
        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
            this.securityKeyDelete = sectionSecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;

        }

        activate(): any {
            this.addedServiceCategories = (this.model) as Model.ServiceCategoryPriority;
            super.activate();
        }

        preSave() {
            super.preSave();
        }

        getTypeaheadCriteria(): any {
            let criteria: any = {};
            if (this.identityService.inCentralOfficeMode()) {
                criteria.coFilterByLocationId = this.identityService.locationId;
                criteria.coSearchType = Model.CoSearchType.CentralOffice;
            } else {
                criteria.coFilterByLocationId = this.identityService.locationId;
                criteria.coSearchType = Model.CoSearchType.Location;
                criteria.coSearchResultFilter = Model.CoSearchResultsFilter.LocationOwned;
            }
            return criteria;
        }

        getServiceCategory(item: any, alreadyExists: any): any {

            var subCategories: any = "";
            if ((item.isPrioritizeSubCategories || !alreadyExists) && Model.Guard.isNothing(item.subCategories))
                subCategories = this.dataService.customMethodData("/api/ServiceCategory/" + item.id, 'Get', this.getTypeaheadCriteria())
                    .then((response) => {
                        if (Model.Guard.isSomething(response.data))
                            return response.data.subCategories;
                    });


            return subCategories;
        }

        addCategory = (category) => {
            if (category == "" || Model.Guard.isNothing(category)) {
                return;
            }
            let alreadyExists = false;
            _.find(this.model.serviceCategoryList,
                function (item: any) {
                    if (item.displayName == category.displayName) {
                        alreadyExists = true;
                        return alreadyExists;
                    } else {
                        return false;
                    }
                });
            if (!alreadyExists) {
                this.getServiceCategory(category, alreadyExists).then((response) => {                 
                    category.homeLocationId = category.ownedByLocationId;
                    this.model.serviceCategoryList.push(category);
                    this.selectedCategory = "";
                });
            }
        }

        removeCategory = (category) => {

            let index = _.findIndex(this.model.serviceCategoryList, function (item: any) {
                if (category.id == item.id) {
                    return true
                }
                else {
                    return false
                }
            });
            this.model.serviceCategoryList.splice(index, 1);
        }

        hasEditPermision = (item) => {
            var locationId: any;
            if (this.identityService.isSingleLocation()) 
            {
                return true;
            } 
            if (Model.Guard.isSomething(item.ownedByLocationId))
                locationId = item.ownedByLocationId;
            else {
                locationId = item.homeLocationId;
            }            
            return locationId == this.identityService.locationId;
        }

        switch = (index1: number, index2: number, array: any, parentIndex?: number) => {
            array = this.model.serviceCategoryList;          
            if (array[index1] && array[index2]) {
                var temp = array[index2];
                array[index2] = array[index1];
                array[index1] = temp;
            }
        }

        updateList = (array: any) => {
            array = _.sortBy(array, (item: any) => { return item.displayposition });
            return array;
        }
    }
}
